import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
  {
    x: 2415,
    y: 1875,
    // x: 2480,
    // y: 1860,
    name: '',
    color: 0x9932cc,
    scale : 0.2,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'gate_1',
      nodes: {
        gate_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Pintu ini terbuka?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.png',
          nextDialogId : "gate_2"
        },
        gate_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Apa ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.png',
          nextDialogId : "gate_3"
        },
        gate_3: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Ada kain berdarah yang tersangkut di pintu ini. Dari manakah kira-kira?',
          //TODO add state kain, tambah dialog Yan mendapatkan bukti sobekan kain
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.png',
          nextDialogId : "gate_3",
          isEnd : true,
        },
      },
    },
  },
  {
    x: 2340,
    y: 720,
    name: 'Elsa',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_elsa.png', // Use NPC image
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Terima kasih atas bantuannya ya, Yan.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Aku cuma pendatang disini, tidak bermaksud apa-apa. Semoga anggota desa lain bisa paham.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
      },
    },
  },
  {
    x: 2400,
    y: 740,
    name: 'Diana',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    repeatable : true,
    dialogTree: {
      startDialogId: 'diana_1',
      nodes: {
        diana_1: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Aku ingin situasi di desa kembali damai seperti sebelumnya.`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : 'diana_2'
        },
        diana_2: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Bagaimana kak, apakah sudah berbicara dengan warga-warga desa yang lain?`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : 'diana_3'
        },
        diana_3: {
          id: 'diana_3',
          speaker: '',
          text : "",
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Aku masih ingin berbicara dengan yang lain',
              nextDialogId: 'diana_4',
              isEnd : true,
            },
            {
              text: 'Sudah, sepertinya saatnya kita istirahat.',
              nextDialogId: 'diana_4',
            },
          ],
        },
        diana_4: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Baiklah ayo kita pulang`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : 'diana_5'
        },
        diana_5: {
          id: 'diana_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId : 'diana_6'
        },
        diana_6: {
          id: 'diana_1',
          speaker: 'Elsa',
          text: `Hari ini sangat melelahkan`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_7'
        },
        diana_7: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Aku juga sangat sedih, kejadian hari ini. Persis di ulang tahun ku`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_8'
        },
        diana_8: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Sepertinya ini ulang tahun terburuk ku.`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_9'
        },
        diana_9: {
          id: 'diana_1',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          choices: [
            {
              text: 'Oiya, aku belum mengucapkan, selamat ulang tahun',
              nextDialogId: 'diana_b2',
              //Add hostility
            },
            {
              text: 'Tenang saja, semua akan berlalu dan situasi akan menjadi normal kembali',
              nextDialogId: 'diana_b2',
            },
            {
              text: 'Berikan Diana Aliktab',
              requirements: {
                requiredItems: [{ itemId: 'bible', quantity: 1 }],
              },
              consumeItems: [
                { itemId: 'bible', quantity: 1 }
              ],
              nextDialogId: 'diana_gift_bible',
            },
            {
              text: 'Berikan Diana Boneka',
              requirements: {
                requiredItems: [{ itemId: 'teddy_bear', quantity: 1 }],
              },
              consumeItems: [
                { itemId: 'teddy_bear', quantity: 1 }
              ],
              nextDialogId: 'diana_gift_bear',
            },
            {
              text: 'Berikan Diana Liontin',
              requirements: {
                requiredItems: [{ itemId: 'liontin', quantity: 1 }],
              },
              consumeItems: [
                { itemId: 'liontin', quantity: 1 }
              ],
              nextDialogId: 'diana_gift_liontin',
            },
          ],
        },
        diana_gift_liontin: {
          id: 'diana_gift_bible',
          speaker: 'Yan',
          text: `Selamat ulang tahun Diana, walaupun hadiah ini bukan apa-apa semoga bisa sedikit menghibur`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          storyActions : [
            { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
          ],
          nextDialogId : 'diana_c1'
        },
        diana_c1: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Kak Yan, terima kasih, aku sangat terharu`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_c2'
        },
        diana_c2: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Wah, lucu sekali. Di liontin ini ada foto kita berdua saat kecil.`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/cutscene/liontin.png',
          nextDialogId : 'diana_b2'
        },
        diana_gift_bible: {
          id: 'diana_gift_bible',
          speaker: 'Yan',
          text: `Selamat ulang tahun Diana, walaupun kejadian buruk, ingatlah Tuhan selalu bersama mu`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          storyActions : [
            { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
          ],
          nextDialogId : 'diana_10'
        },
        diana_gift_bear: {
          id: 'diana_gift_bear',
          speaker: 'Yan',
          text: `Selamat ulang tahun Diana, walaupun hadiah ini bukan apa-apa semoga bisa sedikit menghibur`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          storyActions : [
            { type: 'addCustomValue', value: {key : "general_karma", value : -1} },
          ],
          nextDialogId : 'diana_10'
        },
        diana_b1: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Kak Yan, terima kasih, aku sangat terharu`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_b2'
        },
        diana_b2: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Aku merasa lebih baik sekarang. Terima kasih`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_b3'
        },
        diana_b3: {
          id: 'diana_1',
          speaker: 'Elsa',
          text: `Sudah malam, ayo kita beristirahat dulu. `,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_b4'
        },
        diana_b4: {
          id: 'diana_1',
          speaker: 'Elsa',
          text: `Selamat malam Yan`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/kamar_diana.png',
          nextDialogId : 'diana_b5'
        },
        diana_b5: {
          id: 'diana_1',
          speaker: '',
          text: `...`,
          backgroundImage: '/assets/cutscene/black.png',
          nextDialogId : 'diana_b7',
          sfx:"openDoor"
        },
        diana_b7: {
          id: 'diana_1',
          speaker: 'Yan',
          text: `Saatnya beristirahat`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/kamar_yan.png',
          nextDialogId : 'diana_b8'
        },
        diana_b8: {
          id: 'diana_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/black.png',
          storyAction: { type: 'nextDay', value: 0 },
          sfx : "openDoor"
        },
      },
    },
  },
  {
    x: 2500,
    y: 850,
    name: 'Romo Darius',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_darius.png',
    dialogTree: {
      startDialogId: 'romo_1',
      nodes: {
        romo_1: {
          id: 'romo_1',
          speaker: 'Romo Darius',
          text: `Sangat disayangkan, kita kehilangan satu anggota keluarga hari ini`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "romo_2",
        },
        romo_2: {
          id: 'romo_2',
          speaker: 'Romo Darius',
          text: `Apakah adik mu dan teman mu tidak apa2? mereka sepertinya cukup terdampak`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Mereka tidak apa-apa romo.',
              nextDialogId: 'romo_a1',
              //Add hostility
            },
            {
              text: 'Mereka prihatin kenapa mereka yang dituduh.',
              nextDialogId: 'romo_b1',
            },
          ],
        },
        romo_a1 : {
          id: 'romo_a1',
          speaker: 'Romo Darius',
          text: `Terima kasih atas kesabarannya, dan marilah kita terus berdoa untuk Sondakh`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
        romo_b1 : {
          id: 'romo_b1',
          speaker: 'Romo Darius',
          text: `Begitu ya...`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_b2',
        },
        romo_b2 : {
          id: 'romo_b1',
          speaker: 'Romo Darius',
          text: `Saya harap kalian bersabar ya. Bagaimanapun semua orang sedang berduka.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_b3',
        },
        romo_b3 : {
          id: 'romo_b1',
          speaker: 'Romo Darius',
          text: `Holga pasti sangat sedih dan masih dalam keadaan syok.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_b4',
        },
        romo_b4 : {
          id: 'romo_b1',
          speaker: 'Romo Darius',
          text: `Ato... terlepas perawakannya, dia sangat peduli kepada semua orang di desa.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_b5',
        },
        romo_b5 : {
          id: 'romo_b1',
          speaker: 'Romo Darius',
          text: `Pasti dia sedang penuh emosi.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: 'romo_a1',
        },
      },
    },
  },
  {
    x: 2700,
    y: 950,
    name: 'Holga',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_holga.png',
    repeatable : true,
    dialogTree: {
      startDialogId: 'holga_1',
      nodes: {
        holga_1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Sangat malang sekali Sondakh....`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "holga_2",
        },
        holga_2: {
          id: 'holga_2',
          speaker: 'Holga',
          text: `Aku masih tidak percaya dia sudah hilang`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "holga_3",
        },
        holga_3: {
          id: 'holga_2',
          speaker: 'Holga',
          text: `Siapa yang akan menjaga dan mengasuh aku?`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "holga_4",
        },
        holga_4: {
          id: 'holga_2',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Saya mengungkapkan belasungkawa sebesar-besarnya.',
              nextDialogId: 'holga_a1',
            },
            {
              text: 'Temanku, Elsa ingin mengucapkan turut berduka cita.',
              nextDialogId: 'holga_a1',
            },
            {
              text: 'Ini Panada dari nenek',
              nextDialogId: 'holga_b1',
              requirements: {
                requiredItems: [{ itemId: 'panada', quantity: 1 }],
              },
              consumeItems: [
                { itemId: 'panada', quantity: 1 }
              ],
              storyActions: [
                { type: 'addCustomValue', value: {key : "holga_affinity", value : 1} },
                { type: 'addState', value: "HOLGA_PANADA_POISONED" },
              ],
            },
            {
              text: 'Elsa ingin memberikan sekotak Panada ini untuk ibu.',
              nextDialogId: 'holga_c1',
              consumeItems: [
                { itemId: 'panada', quantity: 1 }
              ],
              requirements: {
                requiredItems: [{ itemId: 'panada', quantity: 1 }],
              },
              storyActions: [
                { type: 'addCustomValue', value: {key : "holga_elsa_affinity", value : 1} },
                { type: 'addState', value: "HOLGA_PANADA_POISONED" },
              ],
            },
          ],
        },
        holga_a1: {
          id: 'holga_a1',
          speaker: 'Holga',
          text: `Apa gunanya ucapan itu. Kata-kata tidak bisa mengubah apa-apa`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "holga_a2",
        },
        holga_a2: {
          id: 'holga_a1',
          speaker: 'Holga',
          text: `Tidak ada yang bisa memperbaiki situasi ini.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
        holga_b1: {
          id: 'holga_a1',
          speaker: 'Holga',
          text: `Nenekmu.. agak tidak biasa nenekmu memberikan ini.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "holga_b2",
        },
        holga_b2: {
          id: 'holga_a1',
          speaker: 'Holga',
          text: `Sampaikan terima kasih ku ke nenekmu.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
        holga_c1: {
          id: 'holga_c1',
          speaker: 'Holga',
          text: `....`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "holga_c2",
        },
        holga_c2: {
          id: 'holga_c1',
          speaker: 'Holga',
          text: `Sampaikan terima kasih ku.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd: true
        },
      },
    },
  },
  {
    x: 2800,
    y: 1050,
    name: 'Ato',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_ato.png', // Marah-marah. bisa kasi minum
    repeatable : true,
    dialogTree: {
      startDialogId: 'ato_1',
      nodes: {
        ato_1: {
          id: 'ato_1',
          speaker: 'Ato',
          text: `Kenapa kamu harus membawa pulang teman mu itu!`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "ato_2",
        },
        ato_2: {
          id: 'ato_2',
          speaker: 'Ato',
          text: `Teman mu langsung membawa musibah bagi desa ini`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "ato_3",
        },
        ato_3: {
          id: 'ato_2',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Elsa adalah orang baik, tidak mungkin dia melakukan ini.',
              nextDialogId: 'ato_4',
            },
            {
              text: 'Elsa memang yang menemukan Sondakh, tetapi bukan berarti itu tanggung jawab Elsa.',
              nextDialogId: 'ato_4',
            },
            {
              text: 'Elsa menitipkan untuk memberikan ini sebagai tanda damai.',
              nextDialogId: 'ato_a1',
              requirements: {
                requiredItems: [{ itemId: 'cap_tikus', quantity: 1 }],
              },
              consumeItems: [
                { itemId: 'cap_tikus', quantity: 1 }
              ],
            },
          ],
        },
        ato_4: {
          id: 'ato_4',
          speaker: 'Ato',
          text: `Itu hanya alasan.`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId : "ato_5",
        },
        ato_5: {
          id: 'ato_4',
          speaker: 'Ato',
          text: `Kondisi disini aman-aman saja sampai dia datang`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true,
        },
        ato_a1: {
          id: 'ato_a1',
          speaker: 'Ato',
          text: `Teman mu, aku bisa maafkan untuk kali ini. Tapi aku tetap mengawasi`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          storyAction: { type: 'addCustomValue', value: {key : "ato_elsa_affinity", value : 1} },
          isEnd: true,
        },
      },
    },
  },
  {
    x: 2400,
    y: 1050,
    name: 'Bunga',
    flipSprite : true,
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_bunga.png', // Kita tanya teori bunga / kenapa kita di sus, bunga jelasin tentang songko
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'bunga_1',
          speaker: 'Bunga',
          text: `Halo Yan`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_2",
        },
        bunga_2: {
          id: 'bunga_2',
          speaker: 'Bunga',
          text: `Bagaimana kabar Diana.. aku sedikit prihatin`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_3",
        },
        bunga_3: {
          id: 'bunga_3',
          speaker: 'Bunga',
          text: `Pasti kejadian tadi sangat traumatik.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_4",
        },
        bunga_4: {
          id: 'bunga_3',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Dia lebih prihatin kenapa warga desa mulai menuduh-nuduh Elsa',
              nextDialogId: 'bunga_5',
            },
            {
              text: 'Kita bingung kenapa orang desa sangat cepat marah dan menuduh',
              nextDialogId: 'bunga_5',
            },
          ],
        },
        bunga_5: {
          id: 'bunga_5',
          speaker: 'Bunga',
          text: `Sebetulnya terkait itu... aku mengerti`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_6",
        },
        bunga_6: {
          id: 'bunga_6',
          speaker: 'Bunga',
          text: `Sejak keadaan tadi semua langsung teringat kejadian 15 tahun lalu, saat itu kita masih kecil`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_7",
        },
        bunga_7: {
          id: 'bunga_7',
          speaker: 'Bunga',
          text: `Tentu kamu ingat kan? Walaupun kita masih kecil `,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_8",
        },
        bunga_8: {
          id: 'bunga_8',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          choices: [
            {
              text: 'Apakah kamu sedang berbicara tentang Songko?',
              nextDialogId: 'bunga_9',
            },
            {
              text: 'Sudah lama sekali kejadiannya, aku sudah lupa.',
              nextDialogId: 'bunga_9a',
            },
          ],
        },
        bunga_9a: {
          id: 'bunga_9a',
          speaker: 'Bunga',
          text: `Banyak wanita muda yang ditemukan meninggal, dan warga desapun langsung menuduh Songko.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_10",
        },
        bunga_9: {
          id: 'bunga_9',
          speaker: 'Bunga',
          text: `Betul sekali.. aku pun tidak ingat detilnya, tetapi banyak wanita muda yang meninggal dalam waktu singkat`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_10",
        },
        bunga_10: {
          id: 'bunga_9',
          speaker: 'Bunga',
          text: `Ibu mu pun hilang tanpa jejak.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_11",
        },
        bunga_11: {
          id: 'bunga_9',
          speaker: 'Bunga',
          text: `Dan tidak ada pelaku yang berhasil ditangkap.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          nextDialogId: "bunga_12",
        },
        bunga_12: {
          id: 'bunga_9',
          speaker: 'Bunga',
          text: `Karena kematian Sondakh, sekarang semua orang percaya Songko telah kembali, dan Elsa lah Songko.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/gereja.png',
          isEnd : true
        },
      },
    }
  },
  {
    x: 1950,
    y: 1520,
    name: 'Nenek',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_nenek1.png',//Nenek ngasih panada
    repeatable : false,
    flipSprite : true,
    dialogTree: {
      startDialogId: 'nenek_1',
      nodes: {
        nenek_1: {
          id: 'nenek_1',
          speaker: 'Nenek',
          text: `Halo Yan, kenapa mukamu pucat sekali?`,
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_c1",
        },
        nenek_c1: {
          id: 'nenek_c1',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Sondakh ditemukan meninggal di pinggir danau.',
              nextDialogId: 'nenek_c2',
              //Add hostility
            },
            {
              text: 'Aku baru selesai melayat..',
              nextDialogId: 'nenek_c2',
            },
          ],
        },
        nenek_c2: {
          id: 'nenek_c2',
          speaker: 'Nenek',
          text: 'Ya ampun, malang sekali. Nenek baru dengar',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_c3",
        },
        nenek_c3: {
          id: 'nenek_c2',
          speaker: 'Nenek',
          text: 'Nenek hari ini seharian di rumah tidak mendengar kabar',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_c4",
        },
        nenek_c4: {
          id: 'nenek_c2',
          speaker: '',
          text: '',
          choices: [
            {
              text: 'Orang-orang desa sangat marah dan menuduh Elsa',
              nextDialogId: 'nenek_c5',
              //Add hostility
            },{
              text:  'Elsa sekarang sedang disalahkan oleh penduduk desa.',
              nextDialogId: 'nenek_c5',
              //Add hostility
            },
          ],
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
        },
        nenek_c5: {
          id: 'nenek_c5',
          speaker: 'Nenek',
          text: 'Begitu ya',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_c6",
        },
        nenek_c6: {
          id: 'nenek_c6',
          speaker: 'Nenek',
          text: 'Kalian sabar ya. Holga memang seperti itu orangnya. Nenek juga tidak suka.',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_2",
          isEnd : true
        },
        nenek_2: {
          id: 'nenek_2',
          speaker: 'Nenek',
          text: 'Hari ini nenek membuat panada, apa kamu mau? Semoga bisa menghibur.',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_3",
        },
        nenek_3: {
          id: 'nenek_3',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Boleh, terima kasih nek',
              nextDialogId: 'nenek_a1',
              storyAction: { type: 'addState', value: "YAN_PANADA_POISON" },
            },
            {
              text: 'Aku tidak lapar',
              nextDialogId: 'nenek_b1',
              itemReward: { itemId: 'panada', quantity: 1},
            },
          ],
        },
        nenek_b1: {
          id: 'nenek_b1',
          speaker: 'Nenek',
          text: 'Kalau begitu, kita bungkus saja panadanya. Supaya bisa kamu makan nanti.',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_b2",
        },
        nenek_b2: {
          id: 'nenek_b1',
          speaker: '',
          text: 'Yan mendapatkan satu kotak panada!',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_c1",
          isEnd : true
        },
        nenek_a1: {
          id: 'nenek_a1',
          speaker: 'Yan',
          text: '...',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_a2",
          sfx : "eating"
        },
        nenek_a2: {
          id: 'nenek_a1',
          speaker: 'Yan',
          text: '...',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_a3",
          sfx : "eating"
        },
        nenek_a3: {
          id: 'nenek_a3',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          choices: [
            {
              text: 'Memang, panada nenek paling enak',//Gimana caranya nanti dia mati tapi enggak langsung
              nextDialogId: 'nenek_aa1',
              //Add hostility
            },
            {
              text: 'Sudah lama sekali tidak memakan panada nenek.',
              nextDialogId: 'nenek_ab1',
            },
          ],
        },
        nenek_aa1: {
          id: 'nenek_a1',
          speaker: 'Nenek',
          text: 'Nenek menggunakan bahan terbaik.',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_aa2",
        },
        nenek_aa2: {
          id: 'nenek_aa2',
          speaker: 'Nenek',
          text: 'Dan tentu saja, ada resep rahasianya yang nanti akan kamu rasakan.',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_c1",
        },
        nenek_ab1: {
          id: 'nenek_ab1',
          speaker: 'Nenek',
          text: 'Iya, membuat Panada ini, sangat sulit. Nenek butuh seharian.',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_ab2",
        },
        nenek_ab2: {
          id: 'nenek_ab2',
          speaker: 'Nenek',
          text: 'Hari ini seharian nenek seharian di rumah membuat Panada.',
          characterImage: '/assets/character/v2/nenek.png',
          backgroundImage: '/assets/backdrop/desa.png',
          nextDialogId : "nenek_aa2",
          isEnd : true,
        },
      },
    },
  },
];

export default config;
